import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { enterKeyPressed } from '../../utils/general/enterKey';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { IReducerState, OffCuffTabType, IByAuthorData, IByAllAuthors } from '../../states/renditionStates';
import AuthorList from '../rightPartRelated/authorList/authorList';
import { isHTMLLightRendition, isAppInsideCVResearchUIiFrame, getCVFrameUrl } from '../../utils/general/general';
import MoreTab from "../leftMenuRelated/moreTab";
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';

export interface IProps {
    mode: OffCuffTabType;
    initialData: any;
    docHeaderJsonData: any;
    byAuthorData?: IByAuthorData;
    byAllAuthors?: IByAllAuthors;
    authorName?: string;
    showOldBranding: boolean;
    analystSubscriptionData: any;
    menuCode: any
}

export class OffCuffAuthorTab extends React.Component<IProps, any> {

    private static offCuffCVRUrl = '/cvr/citiresearchui/eppublic/off_the_cuff';
    public CONTROL_BOX_SHARE: any = React.createRef();

    constructor(props: any) {
        super(props);
        this.state = {
          isRightClickedUrl: false,
        };
    }

    public handleMouseDown = (event: any) => {
      event.preventDefault();
      if (event.button === 2) {
          this.setState({ isRightClickedUrl: true });
      }
      else {
          this.setState({ isRightClickedUrl: false });
      }
    }

    public componentDidMount() {
      this.props.initialData && this.CONTROL_BOX_SHARE.current && checkDomEntitlement(this.CONTROL_BOX_SHARE.current);
    }

    public getAllTopics() {
        return (
            <div className='all-topics' title="All Topics">
                <a onClick={() => RSCH_HTML_TRACKING_CONFIG.trackBlogAllTopics()}
                   onKeyPress={(e: any) =>
                     enterKeyPressed(e, RSCH_HTML_TRACKING_CONFIG.trackBlogAllTopics())
                   }
                   href={OffCuffAuthorTab.offCuffCVRUrl}
                   tabIndex={0}
                   role="link"
                   aria-label="All Topics"
                   target={this.targetValue('_parent')}
                >All Topics</a>
            </div>
        );
    }

    public getTopicsByAuthors() {
        const { mode, byAllAuthors, docHeaderJsonData, menuCode} = this.props;
        const authors = byAllAuthors?.allAuthorsName;
        const isJP = docHeaderJsonData.metadata.isJP;
        if (mode === OffCuffTabType.ByAuthor || !authors || authors.length === 0) return null;
        return (
            <div className='topics author-topics'>
               {authors.map((item) => (
                <div className='topics-item d-block' key={item.analystSoeId} title={`${isJP ? item.analystName.ja : item.analystName.en}(AC)`}>
                  <div className="topic-name text-overflow">
                    <a
                      target={this.targetValue('_self')}
                      href={this.state.isRightClickedUrl? getCVFrameUrl(menuCode, item.postUrl, 'all_research') : item.postUrl}
                      role="link"
                      aria-label={isJP ? item.analystName.ja : item.analystName.en}
                      onClick={() => RSCH_HTML_TRACKING_CONFIG.trackBlogOtherAuthors()}
                      onKeyPress={(e: any) =>
                        enterKeyPressed(e, RSCH_HTML_TRACKING_CONFIG.trackBlogOtherAuthors())
                      }
                      onMouseDown={(e) => this.handleMouseDown(e)}
                      tabIndex={0}
                      className='x-rsch-hyperlink ellipsis'
                    >
                      {isJP ? item.analystName.ja : item.analystName.en}
                    </a>
                    <sup>AC</sup>&nbsp;
                    <span className='text'>({item.totalPosts} Post{item.totalPosts > 1 ? 's' : ''}) </span>
                  </div>
                  {item.sector && <span>{item.sector}</span>}
                </div>
               ))}
            </div>
        );
    }
    public getTopicsByAuthor() {
        const { mode, byAuthorData, authorName, docHeaderJsonData, menuCode} = this.props;
        const list = byAuthorData?.otherTopics;
        const lang = docHeaderJsonData.metadata.isJP ? 'ja' : 'en';
        const encodeUrl = encodeURIComponent(`lang=${lang}&authorSoeid=${docHeaderJsonData.authors?.data?.[0]?.analystId}`);
        const hrefStr = `${OffCuffAuthorTab.offCuffCVRUrl}?filters=${encodeUrl}`;
        if (mode === OffCuffTabType.ByAllAuthors || !list || list.length === 0) return null;
        return (
            <div className='topics'>
                <div className="topics-title" title={`Other Topics by ${authorName || ''}`}>Other Topics by {authorName || ''}</div>
                {list.map((item) => (
                  <span className='topics-item' key={item.topicName} title={item.topicName}>
                    <a target={this.targetValue('_self')}
                       href={this.state.isRightClickedUrl? getCVFrameUrl(menuCode, item.postUrl, 'all_research') : item.postUrl}
                       onClick={() => RSCH_HTML_TRACKING_CONFIG.trackBlogOtherTopics()}
                       onKeyPress={(e: any) =>
                         enterKeyPressed(e, RSCH_HTML_TRACKING_CONFIG.trackBlogOtherTopics())
                       }
                       onMouseDown={(e) => this.handleMouseDown(e)}
                       role="link" aria-label={item.topicName} tabIndex={0} className='x-rsch-hyperlink ellipsis'>{item.topicName}</a>
                    <span className='text'>&nbsp;({item.totalPosts} Post{item.totalPosts > 1 ? 's' : ''}) </span>
                  </span>
                ))}

                {/* <span className='topics-item' key={`More Topics by ${authorName || ''}`} title={`More Topics by ${authorName || ''}`}>
                  <a target={this.targetValue('_parent')}
                      href={hrefStr}
                      onClick={() => RSCH_HTML_TRACKING_CONFIG.trackBlogOtherTopics()}
                      onKeyPress={(e: any) =>
                        enterKeyPressed(e, RSCH_HTML_TRACKING_CONFIG.trackBlogOtherTopics())
                      }
                      role="link" aria-label={`More Topics by ${authorName || ''}`} tabIndex={0} className='x-rsch-hyperlink ellipsis'>More Topics</a>
                </span> */}
            </div>
        );
    }

    public render() {
        const { initialData, docHeaderJsonData, mode, showOldBranding,analystSubscriptionData } = this.props;
        return (
            <div className='author-tab'>
                {mode === OffCuffTabType.ByAuthor && (
                    <div style={{ borderBottom: '1px solid #eee' }}>
                        <AuthorList
                            mainSource={docHeaderJsonData}
                            source={docHeaderJsonData.authors}
                            editor={docHeaderJsonData.i18n.authorEditor}
                            teamDirectoryUrl={
                                initialData.new_team_directory_url
                            }
                            bookMeetingUrl={initialData.new_book_meeting_url}
                            showOldBranding={showOldBranding}
                            analystSubscriptionData={analystSubscriptionData}
                        />
                    </div>
                )}
                {!isHTMLLightRendition() && (
                  <>
                    {this.getTopicsByAuthor()}
                    {this.getTopicsByAuthors()}
                    {/* {this.getAllTopics()} */}
                  </>
                )}
                <div data-entitlement="CONTROL_BOX_SHARE" ref={this.CONTROL_BOX_SHARE}>
                  <MoreTab  // share same entitlement with the control box component in LHS
                    hiddenText
                    hiddenReadingList
                    hiddenSaveReport
                    title="Actions"
                    containerStyle={{ borderBottom: "1px solid #eee" }}
                    contentStyle={{ display: "inline-grid", gridTemplateColumns: "repeat(9, 1fr)", gridGap: "8px", paddingBottom: "15px" }}
                    showOldBranding={showOldBranding}
                  />
                </div>
            </div>
        );
    }

    private targetValue(val: string) {
      return isAppInsideCVResearchUIiFrame() ? val : '_blank';
    }
}
const mapStateToProps = (state: IReducerState) => {
    return {
        initialData: state.asyncStateReducer.initialData,
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        byAuthorData: state.offCuffListStateReducer.byAuthorData,
        byAllAuthors: state.offCuffListStateReducer.byAllAuthors,
        menuCode: state.commonStateReducer.menuCode,
    };
};

export default connect(mapStateToProps)(OffCuffAuthorTab);
